var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscrete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Security_crypto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,288c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S273.7,288,256,288z M256,240c-8.8,0-16,7.2-16,16 c0,8.8,7.2,16,16,16c8.8,0,16-7.2,16-16C272,247.2,264.8,240,256,240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,288c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S385.7,288,368,288z M368,240c-8.8,0-16,7.2-16,16 c0,8.8,7.2,16,16,16s16-7.2,16-16C384,247.2,376.8,240,368,240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480,288c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S497.7,288,480,288z M480,240c-8.8,0-16,7.2-16,16 c0,8.8,7.2,16,16,16s16-7.2,16-16C496,247.2,488.8,240,480,240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,232h16v48h-16V232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,232h16v48h-16V232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,288c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S161.7,288,144,288z M144,240c-8.8,0-16,7.2-16,16 c0,8.8,7.2,16,16,16s16-7.2,16-16C160,247.2,152.8,240,144,240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,288c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S49.7,288,32,288z M32,240c-8.8,0-16,7.2-16,16 c0,8.8,7.2,16,16,16s16-7.2,16-16C48,247.2,40.8,240,32,240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,232h16v48h-16V232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,192c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S217.7,192,200,192z M200,144c-8.8,0-16,7.2-16,16 s7.2,16,16,16s16-7.2,16-16S208.8,144,200,144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,192c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S329.7,192,312,192z M312,144c-8.8,0-16,7.2-16,16 s7.2,16,16,16s16-7.2,16-16S320.8,144,312,144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,192c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S441.7,192,424,192z M424,144c-8.8,0-16,7.2-16,16 s7.2,16,16,16s16-7.2,16-16S432.8,144,424,144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,136h16v48h-16V136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,136h16v48h-16V136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,96c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S161.7,96,144,96z M144,48c-8.8,0-16,7.2-16,16 s7.2,16,16,16s16-7.2,16-16S152.8,48,144,48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,96c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S273.7,96,256,96z M256,48c-8.8,0-16,7.2-16,16 s7.2,16,16,16c8.8,0,16-7.2,16-16S264.8,48,256,48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,96c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S385.7,96,368,96z M368,48c-8.8,0-16,7.2-16,16 s7.2,16,16,16s16-7.2,16-16S376.8,48,368,48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,40h16v48h-16V40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,40h16v48h-16V40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,192c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S105.7,192,88,192z M88,144c-8.8,0-16,7.2-16,16 s7.2,16,16,16s16-7.2,16-16S96.8,144,88,144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,136h16v48h-16V136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,384c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S217.7,384,200,384z M200,336c-8.8,0-16,7.2-16,16 s7.2,16,16,16s16-7.2,16-16S208.8,336,200,336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,384c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S329.7,384,312,384z M312,336c-8.8,0-16,7.2-16,16 s7.2,16,16,16s16-7.2,16-16S320.8,336,312,336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,384c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S441.7,384,424,384z M424,336c-8.8,0-16,7.2-16,16 s7.2,16,16,16s16-7.2,16-16S432.8,336,424,336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,328h16v48h-16V328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,328h16v48h-16V328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,480c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S161.7,480,144,480z M144,432c-8.8,0-16,7.2-16,16 s7.2,16,16,16s16-7.2,16-16S152.8,432,144,432z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,480c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S273.7,480,256,480z M256,432c-8.8,0-16,7.2-16,16 s7.2,16,16,16c8.8,0,16-7.2,16-16S264.8,432,256,432z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368,480c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S385.7,480,368,480z M368,432c-8.8,0-16,7.2-16,16 s7.2,16,16,16s16-7.2,16-16S376.8,432,368,432z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,424h16v48h-16V424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,424h16v48h-16V424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,384c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S105.7,384,88,384z M88,336c-8.8,0-16,7.2-16,16 s7.2,16,16,16s16-7.2,16-16S96.8,336,88,336z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,328h16v48h-16V328z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,232h16v48H80V232z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscrete);
export default __webpack_public_path__ + "static/media/discrete.9b1d692dc32bdcbcca5979a0cc6da6f3.svg";
export { ForwardRef as ReactComponent };